import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MatDateFormats, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ErrorMessageComponent } from './presentationals/messages/error-message/error-message.component';
import { NotificationMessageComponent } from './presentationals/messages/notification-message/notification-message.component';
import { SuccessMessageComponent } from './presentationals/messages/success-message/success-message.component';
import { ConfirmMessageComponent } from './presentationals/messages/confirm-message/confirm-message.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { LoaderComponent } from './presentationals/loader/loader.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LanguageSelectorComponent } from './presentationals/language-selector/language-selector.component';
import { AutocompleteSelectComponent } from './presentationals/autocomplete-select/autocomplete-select.component';
import { SafeUrlPipe } from '../core/pipes/safe-url.pipe';
import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from 'ngx-currency';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';
import { ReplacePipe } from '../core/pipes/replace.pipe';
import { FileDropComponent } from './presentationals/file-drop/file-drop.component';

const sharedModules = [
  MatSnackBarModule,
  MatButtonModule,
  MatMenuModule,
  MatIconModule,
  MatTooltipModule,
  MatToolbarModule,
  MatFormFieldModule,
  MatCheckboxModule,
  MatDividerModule,
  MatExpansionModule,
  MatInputModule,
  MatSelectModule,
  MatDatepickerModule,
  MatSlideToggleModule,
  MatRadioModule,
  FormsModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatDatepickerModule,
  MatNativeDateModule,
  ReactiveFormsModule,
  MatCardModule,
  MatRippleModule
]

const sharedComponents = [
  ErrorMessageComponent,
  NotificationMessageComponent,
  SuccessMessageComponent,
  ConfirmMessageComponent,
  LoaderComponent,
  LanguageSelectorComponent,
  AutocompleteSelectComponent,
  FileDropComponent
]

const customPipes = [
  SafeUrlPipe,
  SafeHtmlPipe,
  ReplacePipe
];

const customDirectives = [
  NgxCurrencyDirective
];

const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    sharedComponents, customPipes
  ],
  imports: [
    CommonModule,
    sharedModules,
    TranslateModule,
    RouterModule,
    customDirectives
  ],
  exports: [
    CommonModule,
    sharedModules,
    TranslateModule,
    sharedComponents,
    customPipes,
    customDirectives
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
        appearance: 'outline'
      } as MatFormFieldDefaultOptions,
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    provideEnvironmentNgxCurrency({
      align: "left",
      allowNegative: false,
      allowZero: true,
      decimal: ".",
      precision: 2,
      prefix: "CHF ",
      suffix: "",
      thousands: "'",
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Natural,
    })
  ],
})
export class SharedModule {
  constructor(readonly translateService: TranslateService, readonly dateAdapter: DateAdapter<any>) {
    translateService.onLangChange.subscribe(() => { 
      dateAdapter.setLocale(translateService.currentLang);
    });
  }
}